import { apiUrl, execUrl } from 'utils/commonValues';
import { actionFormat, getFollowOrderArray } from 'utils/commonFunctions';

// Action Types
const SET_INITIAL = 'license/SET_INITIAL';
const GET_LICENSE = 'license/GET_LICENSE';
const CHANGE_PARAM = 'license/CHANGE_PARAM';
const RELOAD_LICENSE = 'license/RELOAD_LICENSE';

// Actions
export const getLicense = (params?: { [key: string]: any }) =>
  actionFormat(GET_LICENSE, params, 'get', `${apiUrl}License`);
export const addLicense = (params?: { [key: string]: any }) =>
  actionFormat(RELOAD_LICENSE, params, 'post', `${apiUrl}License`);
export const updateLicense = (params?: { [key: string]: any }) =>
  actionFormat(RELOAD_LICENSE, params, 'put', `${apiUrl}License`);
export const changeParam = (params: { [key: string]: any }) =>
  actionFormat(CHANGE_PARAM, params, null, '');

// initial state
interface stateType {
  data: { [key: string]: any };
  param: { [key: string]: any };
  needReload: boolean;
  totalPages: number;
  totalCount: number;
  targetAllCount: number;
}

const initialState: stateType = {
  data: {
    result: -1,
    success: [],
    fail: [],
  },
  param: {
    filter: {},
    sort: [{ field: 'status', order: 'DESC' }],
  },
  needReload: false,
  totalPages: 0,
  totalCount: 0,
  targetAllCount: 0
};

// Reducers
export default function (state: { [key: string]: any } = initialState, action: any) {
  switch (action.type) {
    case SET_INITIAL:
      return initialState;
    case GET_LICENSE:
      if (action.payload) {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);
        // 전체 대상자 수
        const { targetAllCount }= data;

        if (!data.error && data.list && Array.isArray(data.list)) {
          state.data = {
            result: 1,
            success: data.list,
            fail: [],
          };
        } else if (data.error && Array.isArray(data.error)) {
          state.data = {
            result: 0,
            success: [],
            fail: data.errror,
          };
        }

        state.needReload = false;
        state.totalPages = totalPages;
        state.totalCount = totalCount;
        state.targetAllCount = targetAllCount;
      }
      return state;
    case CHANGE_PARAM:
      if (action.payload) {
        const { name, value } = action.payload;
        state.param[name] = value;
      }
      return state;
    case RELOAD_LICENSE:
      if (action.payload) {
        state.needReload = true;
      }
      return state;
    default:
      return state;
  }
}
